import type { PropsWithChildren, ReactNode } from 'react';

export function Steps({ children }: PropsWithChildren) {
  return <ol className="help-steps">{children}</ol>;
}

export function Step({ title, children }: PropsWithChildren<{ title?: ReactNode }>) {
  return (
    <li className="help-step">
      <div className="help-step-body">
        {title ? <strong className="help-step-title">{title}</strong> : null}
        <div>{children}</div>
      </div>
    </li>
  );
}
